import React from "react";

import { DefaultButton } from "../inputs/button/DefaultButton";
import { PrimarySubmitButton } from "../inputs/button/PrimarySubmitButton";
import { Stack } from "../layouts/stack/Stack";

export interface FormActionsProps {
    isLoading: boolean;
    submitDisabled?: boolean;
    onCancel(): void;
    testId?: string;
}

export const FormActions: React.FunctionComponent<FormActionsProps> = ({
    onCancel,
    isLoading,
    submitDisabled,
    testId
}: FormActionsProps) => {
    return (
        <Stack horizontal={true} horizontalAlign="end" styles={{ root: { padding: 10 } }} tokens={{ childrenGap: 10 }}>
            <DefaultButton onClick={onCancel} text="Cancel" disabled={isLoading} testId={`cancel-button`} />
            <PrimarySubmitButton
                text="Submit"
                type="loading"
                isLoading={isLoading}
                disabled={submitDisabled}
                testId={testId ?? `submit-button`}
            />
        </Stack>
    );
};
